import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import s from './RecruitmentSteps.css';
import useGetRecruitmentTeam from '../../../common/apiCalls/homePage';

export default function RecruitmentSteps() {
  useStyles(s);
  const { data: homePageInfo = { recruitmentSteps: [] } } = useGetRecruitmentTeam();
  return (
    <>
      {homePageInfo?.recruitmentSteps?.length > 0 && (
        <section>
          <h2>مراحل استخدام</h2>
          <div>
            <div className={s.itemWrapper}>
              {homePageInfo?.recruitmentSteps?.map((item) => (
                <div>
                  <div className={s.circle}>
                    <img src={item.image} alt={item.title} />
                  </div>
                  <h5 className={s.valueTitle}>{item.title}</h5>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}
    </>
  );
}
